import moment from "moment/moment";
// @ts-expect-error pure js
import { currencyFormatter } from "../../api/Functions";
import type {
  JournalCode,
  TypeCompteComptable,
} from "../../models/comptabilite";

export interface Periode {
  year: number;
  month: number;
}

export const JOURNAL_LABELS: Record<JournalCode, string> = {
  BQ: "Banque",
  VT: "Ventes",
  OD: "Opérations diverses",
  AN: "À-nouveaux",
};

export const TYPE_COMPTE_LABELS: Record<TypeCompteComptable, string> = {
  banque: "Banque",
  locataire: "Locataire",
  mandant: "Mandant",
  depot_garantie: "Dépôt de garantie",
  honoraires: "Honoraires",
  tva_collectee: "TVA collectée",
  attente: "Attente",
  virement_interne: "Virements internes",
  prelevement_honoraires: "Prélèvements d'honoraires",
};

export function euros(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  const parsed = typeof value === "number" ? value : parseFloat(value);
  if (Number.isNaN(parsed)) return "—";
  return currencyFormatter(parsed) ?? "—";
}

export function numeroMandant(idProfileBailleur: number): string {
  return `467${String(idProfileBailleur).padStart(8, "0")}`;
}

export function periodeCourante(): Periode {
  const now = moment();
  return { year: now.year(), month: now.month() + 1 };
}

export function periodeToInputValue({ year, month }: Periode): string {
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function inputValueToPeriode(value: string): Periode | null {
  const [year, month] = value.split("-").map(Number);
  if (!year || !month) return null;
  return { year, month };
}

export function periodeLabel({ year, month }: Periode): string {
  return moment(`${periodeToInputValue({ year, month })}-01`).format(
    "MMMM YYYY",
  );
}

// Le back refuse de clôturer un mois tant qu'il n'est pas révolu
// (close_period : `month_end(year, month) >= date.today()`).
export function periodeTerminee({ year, month }: Periode): boolean {
  return moment(`${periodeToInputValue({ year, month })}-01`)
    .endOf("month")
    .isBefore(moment(), "day");
}

export function debutClotureLabel({ year, month }: Periode): string {
  return moment(`${periodeToInputValue({ year, month })}-01`)
    .add(1, "month")
    .format("Do MMMM YYYY");
}
